export const DEFAULT_TEST_KIZ_TEMPLATE =
  '0102901397695771215qyDQsEmMYmF1\u001d91EE11\u001d92ZfcJjzNXAADgH/9okhi84kh+Gu0I51xWwvtJnj9opwc=';

const STORAGE_KEY = 'datamatrix.test-template';

export function getDataMatrixTestTemplate(): string {
  if (typeof window === 'undefined') return DEFAULT_TEST_KIZ_TEMPLATE;
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return stored && stored.trim() ? stored : DEFAULT_TEST_KIZ_TEMPLATE;
}

export function setDataMatrixTestTemplate(value: string) {
  if (typeof window === 'undefined') return;
  const next = value.trim() || DEFAULT_TEST_KIZ_TEMPLATE;
  window.localStorage.setItem(STORAGE_KEY, next);
}
